(function($) {
    /**
     * @class ABDOMap.Polygon
     */
    $.Polygon = class {
        /**
         * Constructor of Polygon
         * @param {Array<ABDOMap.PolygonVertex>} coordinates 
         * @param {Boolean} closed 
         * @param {String} style  
         */
        constructor(coordinates, closed, style) { 
            this.coordinates = coordinates;
            if(!Array.isArray(this.coordinates)) {
                this.coordinates = [];
            }

            this.closed = closed;
            if (typeof(this.closed) === "undefined") {
                this.closed = false;
            }

            this.style = style;
            if (typeof(this.style) === "undefined") {
                this.style = "default";
            }
        } 

        /**
         * Creates 1 or more polygons from url parameters
         * 
         * the type is defined by the way coordinates are sent, e.g.
         * 
         * - latlon=36.6,180.0&latlon=36.66,180.0&style=default&closed=false -> latlon
         * - proj=10000.0,20000.0&proj=10001.0,20001&style=default&closed=false -> projected
         * - vp=0.8,0.7&vp=0.7,0.6&style=default&closed=false -> viewport
         * 
         * @param {String|URLSearchParams} url_params 
         * @returns Array<ABDOMap.Polygon>
         */
        static from_url_params(url_params) {
            this.params = null;
            if (typeof(url_params) === "string") {
                this.params = new URLSearchParams(url_params);
            }
            else if (url_params instanceof URLSearchParams) {
                this.params = url_params;
            }
            else {
                return null;
            }

            let type = null;
            let vertices = [];
            if (this.params.has("latlon")) {
                type = $.PolygonVertexType.latlon;
                vertices = this.params.getAll("latlon"); 
            }
            else if (this.params.has("proj")) {
                type = $.PolygonVertexType.projected;
                vertices = this.params.getAll("proj"); 
            }
            else if (this.params.has("vp")) {
                type = $.PolygonVertexType.viewport;
                vertices = this.params.getAll("vp"); 
            }
            else {
                return null;
            }

            let polygon_vertices = [];
            for (const coords of vertices) {
                const split_coords = coords.split(",");
                if (split_coords.length == 2) {
                    polygon_vertices.push( new $.PolygonVertex( Number(split_coords[0]), Number(split_coords[1]), type ) );
                }
            }


            let style = "default";
            if (this.params.has("style")) {
                style = this.params.get("style");
            }

            let closed = false;
            if (this.params.get("closed")) {
                closed = this.params.get("closed").trim().toLocaleLowerCase() === "true";
            }

            return new $.Polygon(polygon_vertices, closed, style);
        }
    }; 
 

})(ABDOMap);
